import {
    selectNewportVersionDetails,
    selectShowBelowRecommendeWarning,
    selectShowBelowRequiredWarning,
} from 'newport/store/newportAppSlice';
import { useAppSelector } from 'store/hooks';

export const useSelectNewportVersionDetails = () =>
    useAppSelector(selectNewportVersionDetails);
export const useShowRequiredWarning = () =>
    useAppSelector(selectShowBelowRequiredWarning);
export const useShowRecommendedWarning = () =>
    useAppSelector(selectShowBelowRecommendeWarning);

export function useDisplayingNewportVersionWarning() {
    const showRequiredWarning = useShowRequiredWarning();
    const showRecommendedWarning = useShowRecommendedWarning();

    return showRequiredWarning || showRecommendedWarning;
}
